// src/store/slices/projectSlice.ts
import { createAsyncThunk } from '@reduxjs/toolkit';
import { createGenericSlice } from './genericSliceFactory';
import { apiMethods } from '../../services/api';
import type { Project, ApiResponse } from '@/types';

const projectSlice = createGenericSlice<Project>({
    name: 'projects',
    endpoint: '/projects',
});

export const {
    setCurrentItem: setCurrentProject,
    clearError,
    setSelectedIds,
    toggleSelectId,
    clearSelectedIds,
} = projectSlice.actions;

export const {
    fetchActive: fetchActiveProjects,
} = projectSlice.thunks;

export default projectSlice.reducer;
